import { Action } from 'typescript-fsa';

import { createReducer, getArrayAfterAsyncCall } from '@topconagriculture/frontend-utils';

import { getFarmsListRequest, patchFarm } from './farms.actions';
import { Farm } from './farms.types';

export type FarmsState = Farm[];

const initialState: FarmsState = [];

const farmsReducer = createReducer(initialState, {
  [getFarmsListRequest.done.type]: (state: FarmsState, action: Action<any>) =>
    getArrayAfterAsyncCall<any>(state, action),
  [patchFarm.done.type]: (state: FarmsState, action: ReturnType<typeof patchFarm.done>) =>
    state.map((farm) => (farm.id === action.payload.result.id ? action.payload.result : farm)),
});

export default farmsReducer;
